import { render, staticRenderFns } from "./LoaCons6.vue?vue&type=template&id=15800820&"
import script from "./LoaCons6.vue?vue&type=script&lang=js&"
export * from "./LoaCons6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports